var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo && _vm.$company
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": true,
          },
          on: {
            "update:active": [
              function ($event) {
                _vm.isActive = $event
              },
              _vm.close,
            ],
          },
        },
        [
          _c("div", { staticClass: "card" }, [
            _c("header", { staticClass: "modal-card-head" }, [
              _c(
                "p",
                { staticClass: "modal-card-title" },
                [_vm._t("text-title")],
                2
              ),
              _c("button", {
                staticClass: "delete",
                attrs: { "aria-label": "close" },
                on: { click: _vm.close },
              }),
            ]),
            _c("div", { staticClass: "card-content" }, [
              _c(
                "div",
                { staticClass: "content is-size-7 release-notes-content" },
                [
                  _vm._l(_vm.releases, function (release, index) {
                    return [
                      _c("div", { key: index }, [
                        _c("div", { staticClass: "is-size-7 is-italic" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$filters.formatDateLocale(
                                  release.date,
                                  _vm.$user.info.locale
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "is-flex is-align-items-center is-justify-content-space-between",
                          },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "has-text-weight-bold is-underlined",
                                },
                                [_vm._v(_vm._s(release.title))]
                              ),
                            ]),
                            release.link
                              ? _c("div", { staticClass: "mr-2" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: release.link,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon has-text-success",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-open-in-new mdi-12px",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "has-text-success" },
                                        [_vm._v("View")]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "ul",
                          { staticClass: "pb-4" },
                          _vm._l(release.notes, function (note, noteIndex) {
                            return _c("li", { key: noteIndex }, [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.formatNote(note)),
                                },
                              }),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }